<template>
  <DynamicForm
    dynamicFormType="biomicroscopy"
    :answerableId="attendance.id"
    answerableType="Attendance"
    :disabled=true
  />
</template>
<script>

  import DynamicForm from "@/components/dynamic_form/index.vue";

  export default {
    name: "Biomicroscopy2",
    components: {
      DynamicForm,
    },
    props: {
      attendance: Object,
      attendanceEsigned: Boolean,
    },
  };

</script>
<style lang="scss" scoped></style>
